import Element from "config/routes/Element";
import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { ACCOUNT_ROUTES as ROUTES } from "./utils/accountRoutes";

const AccountLayout = lazy(() => import("views/Profile"));
const ProfileTab = lazy(() => import("views/Profile/ProfileTab"));
const PasswordTab = lazy(() => import("views/Profile/PasswordTab"));
const SettingsTab = lazy(() => import("views/Profile/SettingsTab"));

export const accountRoutes = (
  <Route
    path={ROUTES.account}
    element={
      <Element requiredPermission="updateProfile">
        <AccountLayout />
      </Element>
    }
  >
    <Route index element={<Navigate to={ROUTES.profile} replace />} />
    <Route path={ROUTES.profile} element={<ProfileTab />} />
    <Route path={ROUTES.password} element={<PasswordTab />} />
    <Route path={ROUTES.settings} element={<SettingsTab />} />
    <Route path="*" element={<Navigate to={ROUTES.profile} replace />} />
  </Route>
);
